import React, { useState } from "react";
import { Modal } from "rsuite";
import { ptBR } from "date-fns/locale";

import { MdCalendarMonth } from "react-icons/md";

import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

import api from "../../../../services/axios";
import ProfileSelect from "./ProfileSelect";

type UserModel = {
  email: string;
  password: string;
  userName: string;
  jobDescription: string;
  dtOfBirth: Date;
  dtContract: Date;
  profileId: number;
};

const labelCls =
  "mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300";

const inputCls =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 transition-all focus:border-dv-blue-500 focus:outline-none focus:ring-2 focus:ring-dv-blue-500/20 dark:border-white/10 dark:bg-navy-900 dark:text-white";

const ModalAddUser: React.FC<any> = ({
  openAddUserModal,
  setOpenAddUserModal,
  details,
  updateState,
}) => {
  const [email, setEmail] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [jobDescription, setJobDescription] = useState<string>("");
  const [dtOfBirth, setDtOfBirth] = useState<any>();
  const [contractDate, setContractDate] = useState<any>();
  const [profileId, setProfileId] = useState<string>("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  function togglePasswordVisibility() {
    setIsPasswordVisible((prevState) => !prevState);
  }
  const handleClose = () => {
    setOpenAddUserModal(false);
  };

  const handleRegisterUser = async () => {
    const userData = {
      email: email,
      password: password,
      userName: userName,
      jobDescription: jobDescription,
      dtOfBirth: dtOfBirth,
      dtContract: contractDate,
      profileId: Number(profileId),
    };
    // fazera a chamada para a api
    addUser(userData);
    handleClose();
  };

  const handleConstractDatePicker = (date) => {
    const newData = new Date(date);
    setContractDate(newData);
  };

  const handleBithDatePicker = (date) => {
    const newData = new Date(date);
    setDtOfBirth(newData);
  };

  async function addUser(User: UserModel) {
    try {
      setLoading(true);
      const response = await api.post("/Auth/Register", User);

      if (response.status !== 200) {
        let errorMessage =
          response.data.message || JSON.stringify(response.data);
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setLoading(false);
      toast.success("Usuário adicionado com sucesso", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      updateState();
      return response.data;
    } catch (error) {
      console.error("NetWork Error to adding user:", error);
      setErrorMessage("Erro de rede ao adicionar usuário.");
      setLoading(false);
      toast.error("Erro de rede ao adicionar usuário", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
    <>
      <Modal
        backdrop={"static"}
        open={openAddUserModal}
        size={"lg"}
        onClose={handleClose}
      >
        <Modal.Header className="border-b border-gray-100 pb-3 dark:border-navy-700">
          <Modal.Title>
            <span className="text-lg font-bold text-navy-700 dark:text-white">
              Adicionar usuário
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="grid grid-cols-1 gap-x-6 gap-y-4 py-2 sm:grid-cols-2">
            <div className="flex flex-col sm:col-span-2">
              <label htmlFor="add-user-name" className={labelCls}>
                Nome <span className="text-red-500">*</span>
              </label>
              <input
                id="add-user-name"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className={inputCls}
                placeholder="Digite o nome"
                required
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="add-user-email" className={labelCls}>
                E-mail <span className="text-red-500">*</span>
              </label>
              <input
                id="add-user-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputCls}
                placeholder="Digite o e-mail"
                required
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="add-user-job" className={labelCls}>
                Cargo <span className="text-red-500">*</span>
              </label>
              <input
                id="add-user-job"
                value={jobDescription}
                onChange={(e) => setJobDescription(e.target.value)}
                className={inputCls}
                placeholder="Digite o cargo"
                required
              />
            </div>
            <div className="flex flex-col sm:col-span-2">
              <label htmlFor="add-user-password" className={labelCls}>
                Senha <span className="text-red-500">*</span>
              </label>
              <input
                id="add-user-password"
                type={isPasswordVisible ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                className={inputCls}
                placeholder="Digite a senha"
              />
              <label
                htmlFor="add-user-show-password"
                className="mt-2 flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300"
              >
                <input
                  id="add-user-show-password"
                  type="checkbox"
                  className="h-4 w-4"
                  checked={isPasswordVisible}
                  onChange={togglePasswordVisibility}
                />
                Mostrar senha
              </label>
            </div>
            <div className="flex flex-col">
              <label htmlFor="add-user-profile" className={labelCls}>
                Perfil <span className="text-red-500">*</span>
              </label>
              <ProfileSelect
                id="add-user-profile"
                value={profileId}
                onChange={setProfileId}
                personName={userName}
                className={inputCls}
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="add-user-contract" className={labelCls}>
                Data de contratação <span className="text-red-500">*</span>
              </label>
              <DatePicker
                id="add-user-contract"
                showIcon
                selected={contractDate}
                locale={ptBR}
                icon={<MdCalendarMonth className="text-dv-blue-500 text-xl" />}
                dateFormat="dd/MM/yyyy"
                onChange={(date) => handleConstractDatePicker(date)}
                placeholderText="Selecione a data de contratação"
                className={`${inputCls} !h-[42px]`}
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="add-user-birth" className={labelCls}>
                Data de nascimento <span className="text-red-500">*</span>
              </label>
              <DatePicker
                id="add-user-birth"
                showIcon
                selected={dtOfBirth}
                locale={ptBR}
                icon={<MdCalendarMonth className="text-dv-blue-500 text-xl" />}
                dateFormat="dd/MM/yyyy"
                onChange={(date) => handleBithDatePicker(date)}
                placeholderText="Selecione a data de nascimento"
                className={`${inputCls} !h-[42px]`}
              />
            </div>
            {errorMessage && (
              <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 sm:col-span-2 dark:border-red-500/30 dark:bg-red-900/30 dark:text-red-300">
                {errorMessage}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-t border-gray-100 pt-4 dark:border-navy-700">
          <div className="flex w-full flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] disabled:opacity-50 dark:border-white/15 dark:text-gray-200 dark:hover:bg-navy-700"
            >
              Cancelar
            </button>
            <button
              type="submit"
              onClick={handleRegisterUser}
              disabled={
                loading ||
                email.length < 5 ||
                userName.length < 5 ||
                jobDescription.length < 5 ||
                dtOfBirth == null ||
                contractDate == null ||
                password.length < 5 ||
                profileId === ""
              }
              className="dv-sheen flex items-center justify-center gap-1.5 rounded-xl bg-dv-gradient px-5 py-2.5 text-sm font-bold text-white shadow-dv-glow transition-all active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50"
            >
              {loading ? "Processando..." : "Confirmar"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ModalAddUser;
